/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { useEffect, useState } from 'react';
import { UpdateProfileRequest } from '../types/user';
import {
	userService,
	UserListItem,
	LearnerProfile,
} from '../services/userService';

export function useUserProfile() {
	const [profile, setProfile] = useState<LearnerProfile | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);
	const [deleteCoachLoading, setDeleteCoachLoading] = useState(false);
	const [deleteCoachError, setDeleteCoachError] = useState<string | null>(
		null
	);
	const [deleteCoachSuccess, setDeleteCoachSuccess] = useState(false);

	// 🔹 Fetch user profile
	const fetchUserProfile = async () => {

		console.log('🚀 fetchUserProfile called');

		setLoading(true);
		setError(null);

		try {
			const response = await userService.getUserProfile();

			 console.log('✅ Profile response:', response);
			 
			if (response?.data) {
				setProfile(response.data);
			} else if (response) {
				setProfile(response);
			} else {
				throw new Error('No profile data found');
			}
		} catch (err: any) {
			console.error('Error fetching user profile:', err);
			setError(err.message || 'Failed to fetch user profile');
		} finally {
			setLoading(false);
		}
	};

	// 🔹 Update user profile
	const updateProfile = async (data: UpdateProfileRequest) => {
		setLoading(true);
		setError(null);
		setSuccess(false);

		try {
			const response = await userService.updateUserProfile(data);
			if (response.success) {
				setSuccess(true);
				// Refresh the profile after successful update
				await fetchUserProfile();
				window.dispatchEvent(new Event('profileUpdated'));
			} else {
				setError(response.message);
			}
		} catch (err: any) {
			setError(err.message || 'Failed to update profile');
		} finally {
			setLoading(false);
		}
	};

	const downloadFile = async (fileUrl: string) => {
		try {
			const res = await userService.downloadFile(fileUrl);

			if (res.success) {
				return res.base64; // return base64 string
			}
			return null;
		} catch (err) {
			return null;
		}
	};

	const uploadProfilePicture = async (
		file: File,
		type: 'profilepicture' | 'coverphoto' = 'profilepicture'
	) => {
		setLoading(true);
		setError(null);

		try {
			const res = await userService.uploadProfilePicture(file, type);
			if (res.success) {
				// Update the profile state with the new path
				setProfile(prev =>
					prev ? { ...prev, [type]: res.data.path } : prev
				);
				return res.data.path;
			} else {
				setError(res.message);
				return null;
			}
		} catch (err: any) {
			setError(err.message || 'Upload failed');
			return null;
		} finally {
			setLoading(false);
		}
	};
	const [results, setResults] = useState<UserListItem[]>([]);

	const searchUsers = async (
		query: string,
		filters?: { role?: string; limit?: number }
	) => {
		if (!query) {
			setResults([]);
			return;
		}

		setLoading(true);
		setError(null);

		try {
			const data = await userService.searchUsers(query, filters);
			setResults(data);
		} catch (err: any) {
			setError(err.message || 'Search failed');
		} finally {
			setLoading(false);
		}
	};

	const [userById, setUserById] = useState<LearnerProfile | null>(null);

	const fetchUserProfileById = async (
		userId: string
	): Promise<LearnerProfile | null> => {
		if (!userId) return null;

		setLoading(true);
		setError(null);

		try {
			const userProfile = await userService.getUserProfileById(userId);
			// console.log("hook file logs responce",userProfile);
			if (userProfile) {
				setProfile(userProfile); // updates hook state
				setUserById(userProfile); // optional, separate state
				return userProfile; // ✅ return the data
			} else {
				setError('No profile data found for this ID');
				return null;
			}
		} catch (err: any) {
			console.error('Error fetching user profile by ID:', err);
			setError(err.message || 'Failed to fetch user profile by ID');
			return null;
		} finally {
			setLoading(false);
		}
	};

	// 🔹 New state for deletion
	const [deleteLoading, setDeleteLoading] = useState(false);
	const [deleteError, setDeleteError] = useState<string | null>(null);
	const [deleteSuccess, setDeleteSuccess] = useState(false);

	// 🔹 Delete user function
	const deleteUser = async (userId: string, reason?: string) => {
		setDeleteLoading(true);
		setDeleteError(null);
		setDeleteSuccess(false);

		try {
			const res = await userService.deleteUser(userId, reason);
			if (res.success) {
				setDeleteSuccess(true);
				// Optional: refresh users list if needed
				return true;
			} else {
				setDeleteError(res.message);
				return false;
			}
		} catch (err: any) {
			setDeleteError(err.message || 'Failed to delete user');
			return false;
		} finally {
			setDeleteLoading(false);
		}
	};

	const deleteCoach = async (coachId: string, reason?: string) => {
		setDeleteCoachLoading(true);
		setDeleteCoachError(null);
		setDeleteCoachSuccess(false);

		try {
			const res = await userService.deleteCoach(coachId, reason);

			if (res.success) {
				setDeleteCoachSuccess(true);
				return true;
			} else {
				setDeleteCoachError(res.message);
				return false;
			}
		} catch (err: any) {
			setDeleteCoachError(err.message || 'Failed to delete coach');
			return false;
		} finally {
			setDeleteCoachLoading(false);
		}
	};

// useEffect(() => {
//     const handleAuthChange = () => {
//         const token = localStorage.getItem('token');

//         if (token) {
//             fetchUserProfile();
//         } else {
//             setProfile(null);
//         }
//     };

//     // Initial fetch
//     handleAuthChange();

//     // Listen for login/logout/register
//     window.addEventListener('authChanged', handleAuthChange);

//     return () => {
//         window.removeEventListener(
//             'authChanged',
//             handleAuthChange
//         );
//     };
// }, []);
useEffect(() => {
    const handleProfileChange = () => {
        fetchUserProfile();
    };

    const handleAuthChange = () => {
        const token = localStorage.getItem('token');

        if (token) {
            fetchUserProfile();
        } else {
            setProfile(null);
        }
    };

    // Initial fetch
    handleAuthChange();

    // Listen for login/logout/register
    window.addEventListener('authChanged', handleAuthChange);

    // Listen for profile updates
    window.addEventListener('profileUpdated', handleProfileChange);

    return () => {
        window.removeEventListener('authChanged', handleAuthChange);
        window.removeEventListener('profileUpdated', handleProfileChange);
    };
}, []);

	return {
		profile,
		loading,
		error,
		success,
		fetchUserProfile,
		updateProfile,
		downloadFile,
		deleteUser,
		uploadProfilePicture,
		fetchUserProfileById,
		deleteLoading,
		deleteError,
		deleteSuccess,
		setProfile, // <-- ADD THIS
		deleteCoach,
		deleteCoachLoading,
		deleteCoachError,
		deleteCoachSuccess,
	};
}
